import {Component, TemplateRef, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {NgbPopover} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-event-popover',
    templateUrl: './calendar-event-popover.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CalendarEventPopoverComponent {
    template: TemplateRef<any>;
    @ViewChild(NgbPopover, {static: true}) popover: NgbPopover;
}
